import angular = require("angular");
import * as _ from "lodash";

import {ModelBase, BaseModel, modelModule } from "./model";

export class FilesModel extends ModelBase {

	constructor($http: ng.IHttpService, $q: ng.IQService, $log: ng.ILogService, baseModel: BaseModel, private $window: Window) {
		super("api/Images/", $http, $q,$log, baseModel);
	}

	public saveTempCSV(data: string, filename: string, mimetype: string) {
		var deferred: ng.IDeferred<string> = this.$q.defer();

		this.$http.post<string>(this.GetUrl("TempCSV"), {
			FileName: filename,
			MimeType: mimetype,
			Content: data
		})
			.then((data) => {
				deferred.resolve(data.data.replace(/\\|\/|\"|\'/g, ''));
			})
			.catch((err) => {
				this.LogError("saveTempCSV",err);
				deferred.reject(err.data);
			});

		return deferred.promise;
    };

	public saveTempSvgToPdf(data: string, filename: string) {
		var deferred: ng.IDeferred<string> = this.$q.defer();

		this.$http.post<string>(this.GetUrl("SvgPdfExport"), {
			FileName: filename,
			Content: data
		})
			.then((data) => {
				deferred.resolve(data.data.replace(/\\|\/|\"|\'/g, ''));
			})
			.catch((err) => {
				this.LogError("saveTempSvgToPdf",err);
				deferred.reject(err.data);
			});

		return deferred.promise;
	};

	public saveTempHtmlToPdf(data: string, filename: string, css: string) {
		var deferred: ng.IDeferred<string> = this.$q.defer();

		this.$http.post<string>(this.GetUrl("HtmlPdfExport"), {
			FileName: filename,
			Content: data,
			Style: css
		})
			.then((data) => {
				deferred.resolve(data.data.replace(/\\|\/|\"|\'/g, ''));
			})
			.catch((err) => {
				this.LogError("saveTempHtmlToPdf",err);
				deferred.reject(err.data);
			});

		return deferred.promise;
	};

	public downloadTempCSV (id:string) {
		var url = this.GetUrl('TempCSV');
		var t = this.$window.open(url + "?id=" + id, '_blank');
		if (t && t.focus) { t.focus(); }
	}

	public downloadTempPDF(id:string) {
		var url = this.GetUrl('TempPDF');
		var t = this.$window.open(url + "?id=" + id, '_blank');
		if (t && t.focus) { t.focus(); }
	}

	public openTempPDFInNewWindow (id:string) {
		var url = this.GetUrl('TempPDF');
		this.baseModel.openNew(url + "?id=" + id);
	}

	public saveAndDownloadCSV(data:string, filename?:string, mimetype?:string) {

		if (angular.isUndefined(filename)) {
			filename = "chart.csv";
		}

		if (angular.isUndefined(mimetype)) {
			mimetype = "application/octet-stream";
		}

		return this.saveTempCSV(data, filename, mimetype)
			.then((id) => {
				if (id && id.length > 5) {

					this.downloadTempCSV(id);
				}
			});
	}


	public svgPdfExport (svg:string, filename?:string) {
		if (angular.isUndefined(filename)) {
			filename = "temp.pdf";
		}

		return this.saveTempSvgToPdf(svg, filename)
			.then( (id) => {
				if (id && id.length > 5) {
					this.downloadTempPDF(id);
				}
			});
	}

	public htmlPdfExport(html:string, filename?:string, css?:string) {
		if (angular.isUndefined(filename)) {
			filename = "temp.pdf";
		}

		return this.saveTempHtmlToPdf(html, filename, css)
			.then( (id) => {
				if (id && id.length > 5) {
					this.downloadTempPDF(id);
				}
			});
	}

	public htmlPdfExportToNewWindow(html:string, filename?:string, css?:string) {
		if (angular.isUndefined(filename)) {
			filename = "temp.pdf";
		}

		return this.saveTempHtmlToPdf(html, filename, css)
			.then((id) => {
				if (id && id.length > 5) {
					this.openTempPDFInNewWindow(id);
				}
			});
	}

    public downloadInvestmentAcceleratorTemplate(assetId?: number) {
		var deferred: angular.IDeferred<{data:string, filename:string}> = this.$q.defer();
        var url = 'api/ProjPrior/DownloadTemplateFile';       
        var params = {};
         
        if (assetId) {
            params = { assetId: assetId };
            url = 'api/ProjPrior/DownloadTemplateFileForAsset'
        }
        
		this.$http.get(this.baseModel.getUrl(url), {
            params: params,
			responseType: 'arraybuffer'
		})
			.then((data) => {
				var results = { data:null, filename:""};
				results.data = data.data;
				var headerData = data.headers();
				var filename = headerData['content-disposition'] || 'Import Template.xlsx';
				filename = filename.replace(/['"]+/g, '')
				var pos = filename.lastIndexOf('=');
				if (pos > 0) {
					results.filename = filename.slice(pos + 1);
				}
				else {
					results.filename = filename;
				}
				deferred.resolve(results);
			})
			.catch( (data) => {
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
                let obj = {};
                if (decodedString) {
                    obj = JSON.parse(decodedString);
                }
				var error = {
					Message: obj['Message'] || "",
					ExceptionMessage: obj['ExceptionMessage'] || ""
				};
				deferred.reject(error);
			});
		return deferred.promise;
    }

    public getServersForUser(pdServerTypes: number[]) {
        var deferred: ng.IDeferred<model.IPdServerInfo[]> = this.$q.defer();

        this.$http.post<model.IPdServerInfo[]>(this.baseModel.getUrl("api/ProcessData/GetPdServersForUser"),
            {
                "pdServerTypes": pdServerTypes
            })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("getPdServersForUser", data);
                deferred.reject(data.data);
            });

        return deferred.promise;
    }


    public UploadFileToS3(file: any, bucketType: string) {
        var deferred: ng.IDeferred<model.IAWSFileUrl> = this.$q.defer();
        let mylink;
        this.baseModel.getFileUrl(null, file.name, true, file.type, null, bucketType)
            .then((link) => {
                mylink = link;
                this.baseModel.uploadFile(link.Url, file);
            })
            .then(() => {
                deferred.resolve(mylink);
            })
            .catch((error) => {
                this.LogError("UploadFileToS3", error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

	public importExcelToProcessData(uploadService: any, file: any, scenarioName: string, importType: string) {
		var deferred = this.$q.defer();

		//var path = "api/ProcessData/ImportProcessDataFromExcel";

		//if (file.name.substr(file.name.length-3).toLowerCase() == "csv") {
		//	path = "api/ProcessData/ImportProcessDataFromCsv";
  //      }

        var path = "api/ProcessData/ImportAdHocProcessDataFile";

		uploadService.upload({
			url: this.baseModel.getUrl(path),
            file: file,
            data: {
            },
            params: {
                scenarioName: scenarioName,
                importType: importType      
            }
		})
			.success((result) => {   //return data here
				deferred.resolve(result);  //return data here
			})
			.error((error) => {
				deferred.reject(error);
			});
		return deferred.promise;
	}

    public importScheduleStatus(uploadService: any, file: string, selectedAssetId: number, sendEmailStatus: boolean) {
        var deferred: angular.IDeferred<IImportScheduleStatusResult> = this.$q.defer();
        var uploadUrl = 'api/ProjPrior/ImportScheduleStatus';
        uploadService.upload({
            url: this.baseModel.getUrl(uploadUrl),
            file: file,            
            data: {                
            },
            params: {
				selectedAssetId: selectedAssetId,
				sendEmailStatus: sendEmailStatus
            }
        })
            .success((result) => {   //return data here
                deferred.resolve(result);  //return data here
            })
        ['error']((error) => {
            deferred.reject(error);
        });
        return deferred.promise;
    };

		public queueSekoiaExportJob(jobExtId: string) {
			var deferred: ng.IDeferred<atxjobs.ISekoiaExportAWSSQSJob> = this.$q.defer();
			this.$http.get<atxjobs.ISekoiaExportAWSSQSJob>(this.baseModel.getUrl('api/ProjPrior/QueueSekoiaExportJob'), {
					'params': {
							jobExtId: jobExtId
					}
			})
			.then((result: any) => {
					deferred.resolve(result.data);
			})
			.catch((error: any) => {
					this.LogError('queueSekoiaExportJob', error);
					deferred.reject(error.data);
			});
			return deferred.promise;
	}

		public getNewSekoiaExportAWSSQSJob(assetId: number) {
			var deferred: ng.IDeferred<atxjobs.ISekoiaExportAWSSQSJob> = this.$q.defer();
			this.$http.get<atxjobs.ISekoiaExportAWSSQSJob>(this.baseModel.getUrl('api/ProjPrior/CreateExportJob'), {
					'params': {
							selectedAssetId: assetId
					}
			})
			.then((result: any) => {
					deferred.resolve(result.data);
			})
			.catch((error: any) => {
					this.LogError('getNewSekoiaExportAWSSQSJob', error);
					deferred.reject(error.data);
			});

			return deferred.promise;
	}

    public getNewSekoiaImportAWSSQSJob(assetId: number, jobName: string, fileType: string, file: any, sendEmailStatus: boolean) {
        var deferred: ng.IDeferred<atxjobs.ISekoiaImportAWSSQSJob> = this.$q.defer();

        this.$http.get<atxjobs.ISekoiaImportAWSSQSJob>(this.baseModel.getUrl('api/ProjPrior/CreateImportJob'), {
            'params': {
              selectedAssetId: assetId,
              jobName: jobName,
              fileType: fileType,
              sendEmailStatus: sendEmailStatus
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('getNewSekoiaImportAWSSQSJob', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

    public queueSekoiaImportJob(jobExtId: string) {
        var deferred: ng.IDeferred<atxjobs.ISekoiaImportAWSSQSJob> = this.$q.defer();

        this.$http.get<atxjobs.ISekoiaImportAWSSQSJob>(this.baseModel.getUrl('api/ProjPrior/QueueSekoiaImportJob'), {
            'params': {
                jobExtId: jobExtId
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('queueSekoiaImportJob', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

    public queueSekoiaETLToFinalJob(jobExtId: string) {
        var deferred: ng.IDeferred<atxjobs.ISekoiaImportAWSSQSJob> = this.$q.defer();

        this.$http.get<atxjobs.ISekoiaImportAWSSQSJob>(this.baseModel.getUrl('api/ProjPrior/QueueSekoiaETLToFinalJob'), {
            'params': {
                jobExtId: jobExtId
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('queueSekoiaETLToFinalJob', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

    public recordOverwriteDeclination(jobExtId: string) {
        var deferred: ng.IDeferred<atxjobs.ISekoiaImportAWSSQSJob> = this.$q.defer();

        this.$http.get<atxjobs.ISekoiaImportAWSSQSJob>(this.baseModel.getUrl('api/ProjPrior/DeclineImportOverwrite'), {
            'params': {
                jobExtId: jobExtId
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('recordOverwriteDeclination', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

    public assetIsLockedForImportingByUserName(assetId: number, sendEmailStatus: boolean) {
        var deferred: ng.IDeferred<atxjobs.IAssetLockedForImport> = this.$q.defer();

        this.$http.get<atxjobs.IAssetLockedForImport>(this.baseModel.getUrl('api/ProjPrior/LockedForImport'), {
            'params': {
				assetId: assetId,
				sendEmailStatus: sendEmailStatus                
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('assetLockedForImportingByUserName', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
	}

	public downloadAssetAttachments(assetID: string | string[]) {
		let deferred: angular.IDeferred<string> = this.$q.defer();

		if (!_.isArray(assetID)) {
			assetID = [assetID];
		}
		 
		this.$http.post<string>(this.GetUrl('DownloadAttachments'),assetID)
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((error) => {
				this.LogError('downloadAssetAttachments', error);
				deferred.reject(error.data); 
			});

		return deferred.promise; 
	}

	public notificationUrl(groupID: string) {
		let deferred: angular.IDeferred<string> = this.$q.defer();

		this.$http.get<string>(this.GetUrl('DownloadNotification'), {
			'params': {
				group: groupID
			}
		})
			.then((result) => {
				deferred.resolve(result.data);
			})
			.catch((error) => {
				this.LogError('notificationUrl', error);
				deferred.reject(error.data);
			});

		return deferred.promise;
	}

}

modelModule.factory('filesModel', ['$http', '$q', '$log', 'baseModel', '$window', ($http, $q, $log, baseModel, $window) => new FilesModel($http, $q, $log, baseModel, $window)]);


export interface IImportScheduleStatusResult {
    Message: string;
    Success: boolean; 
}


// WEBPACK FOOTER //
// ./Common/Models/FilesModel.ts